import { render } from "./FileUploadPopup.vue?vue&type=template&id=2b9e9c66&scoped=true"
import script from "./FileUploadPopup.vue?vue&type=script&lang=js"
export * from "./FileUploadPopup.vue?vue&type=script&lang=js"

import "./FileUploadPopup.vue?vue&type=style&index=0&id=2b9e9c66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9e9c66"]])

export default __exports__